import _ from 'lodash';

const templates = [
  {
    "_id": 0,
    "name": "",
    "age": "",
    "residence": "",
    "education": "",
    "occupation": "",
    "marital_status": "",
    "persona_image": "/user-blank.png",
    "quote": "",
    "summary": "",
    "comfort_with_technology": {
      "internet": 50,
      "software": 50,
      "mobile_apps": 50,
      "social_network": 50
    },
    "criteria_for_success": "",
    "needs": [],
    "wants": [],
    "values": [],
    "fears": [],
    "logo_image": "/mobilitylabs-logo.svg",
    "theme": "default"
  },
  {
    "_id": 1,
    "name": "Sean Perkins",
    "age": "33",
    "residence": "Washington, DC",
    "education": "Bachelors Degree (BA)",
    "occupation": "Business Owner",
    "marital_status": "Single | No children",
    "persona_image": "/user-sean.png",
    "quote": "I think this idea could work, I just need to put more energy into it.",
    "summary": "Sean is juggling many projects and priorities. He appreciates help from his vendors and employees. When tackling something new he prefers to do some research then consult an expert.",
    "comfort_with_technology": {
      "internet": 80,
      "software": 90,
      "mobile_apps": 80,
      "social_network": 50
    },
    "criteria_for_success": "When a project achieves its goals on time and on budget while delighting users.",
    "needs": [
      "Tangible results",
      "To have project self manage"
    ],
    "wants": [
      "Start small",
      "See results before spending more money"
    ],
    "values": [
      "Detailed planning",
      "Concrete expectations",
      "Decisions backed up by analytics or data"
    ],
    "fears": [
      "Failure",
      "Wasting money",
      "Being too hasty"
    ],
    "logo_image": "/mobilitylabs-logo.svg",
    "theme": "default"
  },
  {
    "_id": 2,
    "name": "Joan Perez",
    "age": "26",
    "residence": "Charlotte, NC",
    "education": "Bachelors Degree",
    "occupation": "Teacher",
    "marital_status": "Single | No children",
    "persona_image": "/user-7.png",
    "quote": "My students come first in everything I do.",
    "summary": "Joan is a new teacher, having recently gotten her certification from a teacher placement agency. She is in her second year of teaching now, starting to get the hang of things more, but also now realizing how much she needs to improve. She wants to get better, but also wants to be smart about it.",
    "comfort_with_technology": {
      "internet": 80,
      "software": 80,
      "mobile_apps": 80,
      "social_network": 80
    },
    "criteria_for_success": "To see all of her students grow 1.5 grade levels.",
    "needs": [
      "Mesaureable impact",
      "To have project self manage"
    ],
    "wants": [
      "Something that doesn't take long to setup",
      "Products that integrate with other existing technology"
    ],
    "values": [
      "Student growth",
      "Time savings",
      "Products that easily fit into her current workflow"
    ],
    "fears": [
      "Cutting into already sparse free time",
      "Starting something that isn't sustainable",
      "Doesn't actually improve student achievement",
      "Someone else has already built what she needs"
    ],
    "logo_image": "/mobilitylabs-logo.svg",
    "theme": "default"
  },
  {
    "_id": 3,
    "name": "Ricky Metzger",
    "age": "Late 20's",
    "residence": "Washington, DC",
    "education": "Bachelor Degree of Fine Art (BFA)",
    "occupation": "Designer",
    "marital_status": "Single | No children",
    "persona_image": "/user-ricky.png",
    "quote": "I love this idea, and I can't wait to test it with our customers!",
    "summary": "Ricky likes to focus heavily on one aspect of a project, and appreciates his vendors handling the other responsibilities. He prefers to use existing best practices before inventing new paradigms.",
    "comfort_with_technology": {
      "internet": 90,
      "software": 60,
      "mobile_apps": 80,
      "social_network": 30
    },
    "criteria_for_success": "When a project achieves its goals on time and on budget while delighting users.",
    "needs": [
      "Excellent User Experience",
      "To be involved in the Design Process"
    ],
    "wants": [
      "Trendy UI",
      "To see User feedback before any major decision"
    ],
    "values": [
      "Detailed communication",
      "Well rounded style guide",
      "Decisions backed up by user research"
    ],
    "fears": [
      "Disappointing Users",
      "Producing a bad product"
    ],
    "logo_image": "/mobilitylabs-logo.svg",
    "theme": "default"
  }
];
export default templates;

export function getTemplate(id) {
  const theId = typeof id === 'number' ? id : 1;
  return _.find(templates, {'_id': theId});
}



// WEBPACK FOOTER //
// ./client/utilities/templates.js